import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { logEvent } from "firebase/analytics";
import { analyticsWebPromise } from "../firebaseConfig";

const reportedFallbacks = new Set();

export const reportWebFeedSource = async ({
    mosqueId,
    source,
    reason = null,
    schemaVersion = 0,
}) => {
    if (source === "legacyFallback") {
        const key = `${mosqueId}:${reason || "none"}:${schemaVersion}`;
        if (reportedFallbacks.has(key)) return;
        reportedFallbacks.add(key);
    }

    const analytics = await analyticsWebPromise;
    if (!analytics) return;

    logEvent(analytics, "public_feed_source", {
        client_type: "web",
        feed_source: source,
        fallback_reason: reason || "none",
        schema_version: schemaVersion,
        mosque_id: mosqueId,
    });
};

export const __resetWebFeedTelemetryForTests = () => reportedFallbacks.clear();

export default function useWebAnalytics() {
    const location = useLocation();

    useEffect(() => {
        analyticsWebPromise.then((analytics) => {
            if (analytics) {
                logEvent(analytics, "page_view", {
                    page_path: location.pathname,
                });
            }
        });
    }, [location]);
}
